import React from "react";
import { Modal, Button } from "@cloud/atom-ui";

export default props => {
  const { visible, modalInfo, handleOk, handleCancel, children } = props;
  return (
    <Modal
      visible={visible}
      title={modalInfo?.title || ""}
      onOk={() => handleOk?.()}
      onCancel={() => handleCancel?.()}
      footer={[
        <Button key="back" onClick={() => handleCancel?.()}>
          {modalInfo?.cancelText || ""}
        </Button>,
        <Button key="submit" type="primary" onClick={() => handleOk?.()}>
          {modalInfo?.okText || ""}
        </Button>
      ]}
    >
      {children}
    </Modal>
  );
};
